import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUnreadConversationIdsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUnreadConversationIdsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, unreadConversationIds: Array<number> } };


export const GetUnreadConversationIdsDocument = gql`
    query GetUnreadConversationIds {
  currentUser {
    id
    unreadConversationIds
  }
}
    `;

/**
 * __useGetUnreadConversationIdsQuery__
 *
 * To run a query within a React component, call `useGetUnreadConversationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadConversationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadConversationIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadConversationIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>(GetUnreadConversationIdsDocument, options);
      }
export function useGetUnreadConversationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>(GetUnreadConversationIdsDocument, options);
        }
// @ts-ignore
export function useGetUnreadConversationIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>;
export function useGetUnreadConversationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnreadConversationIdsQuery | undefined, GetUnreadConversationIdsQueryVariables>;
export function useGetUnreadConversationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>(GetUnreadConversationIdsDocument, options);
        }
export type GetUnreadConversationIdsQueryHookResult = ReturnType<typeof useGetUnreadConversationIdsQuery>;
export type GetUnreadConversationIdsLazyQueryHookResult = ReturnType<typeof useGetUnreadConversationIdsLazyQuery>;
export type GetUnreadConversationIdsSuspenseQueryHookResult = ReturnType<typeof useGetUnreadConversationIdsSuspenseQuery>;
export type GetUnreadConversationIdsQueryResult = Apollo.QueryResult<GetUnreadConversationIdsQuery, GetUnreadConversationIdsQueryVariables>;